import { API_BASE, getAuthHeaders } from './config';

export type TagWithCount = { id: number; name: string; content_count: number };

export type TagContentItem = {
    id: number;
    title: string;
    type: string;
    is_visible: boolean;
    is_premium: boolean;
    created_at: string;
    // opcjonalnie z serwera (nie używamy tu, ale mogą się przydać):
    created_by?: number | null;
    last_edited_by?: number | null;
    cover_image_url?: string | null;
};

export async function fetchAllTags() {
    const res = await fetch(`${API_BASE}/tags`, { headers: getAuthHeaders() });
    if (!res.ok) throw await res.json();
    return res.json() as Promise<TagWithCount[]>;
}

export async function createTag(name: string) {
    const res = await fetch(`${API_BASE}/tags`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify({ name }),
    });
    if (!res.ok) throw await res.json();
    return res.json();
}

export async function updateTag(id: number, name: string) {
    const res = await fetch(`${API_BASE}/tags/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify({ name }),
    });
    if (!res.ok) throw await res.json();
    return res.json();
}

export async function deleteTag(id: number) {
    const res = await fetch(`${API_BASE}/tags/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw await res.json();
    return res.json();
}

export const searchTags = async (query: string) => {
    const res = await fetch(`${API_BASE}/tags/search?q=${encodeURIComponent(query)}`, {
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw await res.json();
    return res.json() as Promise<Array<{ id: number; name: string }>>;
};

export async function searchTagsApi(q: string) {
    return searchTags(q);
}

export async function fetchContentsForTagName(name: string) {
    const res = await fetch(`${API_BASE}/tags?name=${encodeURIComponent(name)}`, {
        headers: getAuthHeaders(),
    });
    if (!res.ok) throw await res.json();
    return res.json() as Promise<TagContentItem[]>;
}
